import { EuiPageContent, EuiSpacer } from "@elastic/eui";
import React, { useContext } from "react";
import { EntityProfileContext } from ".";
import { singular } from "../../../../../utils/stringUtils";
import TripTable from "../../../../trips/components/Table";

import AbstractTableContainer from "../AbstractTable/container";

const renderProfileEntity = ({
    field,
    relationKey,
    customRelationKey,
    entityId,
    entityName,
    entityNameValue,
}) => {
    const url = `${field.entityName}?filter[${relationKey}]=${entityId}${customRelationKey ?? ""}`;

    const entityDefaultObject = {
        [relationKey]: +entityId,
        [singular(entityName)]: entityNameValue,
    };

    switch (field.name) {
        case "trips":
            return (
                <EuiPageContent>
                    <TripTable
                        url={url}
                        relationKey={relationKey}
                    />
                </EuiPageContent>
            );

        default:
            return (
                <AbstractTableContainer
                    options={{ ...field.entityOptions, url }}
                    entityDefaultObject={entityDefaultObject}
                    isFromClient={entityName === "organizations"}
                />
            );
    }
};

const ProfileEntity = ({ field }) => {
    const { entityName, entityId, entity } = useContext(EntityProfileContext);
    let relationKey;
    let customRelationKey;
    if (field.entityName === "contracts") {
        relationKey = "ownerId";
        if (entityName === "drivers") {
            customRelationKey = "&filter[ownerType]=Driver";
        } else if (entityName === "supplires") {
            customRelationKey = "&filter[ownerType]=Supplier";
        }
    } else {
        relationKey = `${singular(entityName)}Id`;
    }

    return (
        <>
            <EuiSpacer size="m" />
            {renderProfileEntity({
                field,
                relationKey,
                customRelationKey,
                entityId,
                entityName,
                entityNameValue: entity.name,
            })}
        </>
    );
};

export default ProfileEntity;
